import { createAsyncThunk } from '@reduxjs/toolkit';
import { TApiaFinderFilter, TAsyncThunkState } from '../../../types';
import { TApiaFilter } from '../../../../../types';
import store from '../../../..';
import { responsiveTableActions } from '../../../../responsiveTableSlice';
import { getCurrentListId } from '../../../../../components/apia/common/lists/hooks/useCurrentListId';
import search from './search';
import { queryActions } from '../../..';
import queriesQueue, { TQueriesActionsChain } from '../../../queueController';
import FiltersSetterController from '../../../../../components/apia/query/components/FiltersSetterComponents/FiltersSettersController';

type TSort = {
  fieldId: string;
  filters: TApiaFilter[];
  forceSearch: boolean;
  query?: {
    workingMode: string;
  };
  avoidEventDetectOnChange?: boolean;
  forceRefreshFromSavedFilters?: boolean;
  fromFiltersSetters?: boolean;
  queueKey?: TQueriesActionsChain;
};

const updateFilter = createAsyncThunk<null, TSort, TAsyncThunkState>(
  'querySlice/refreshFilters',
  async (
    {
      fieldId,
      filters,
      forceSearch,
      query,
      avoidEventDetectOnChange,
      forceRefreshFromSavedFilters,
      fromFiltersSetters = false,
      queueKey = 'directUpdateFilters',
    },
    thunkApi,
  ) => {
    const state = thunkApi.getState().querySlice.queries[fieldId];
    store.dispatch(
      responsiveTableActions.update({
        tableName: getCurrentListId(),
        selectedRows: [],
      }),
    );
    if (!fromFiltersSetters && window.canSaveFilters) {
      const controller = FiltersSetterController.getInstance();
      controller.savedFilters = controller.savedFilters.map((saved) => {
        return { ...saved, selected: false };
      });
    }
    store.dispatch(
      queryActions.setState({
        fieldId,
        filters: (state.filters ?? []).map((innerFilter) => {
          let returnFilter = {
            ...innerFilter,
          };
          filters.forEach((incomingFilter) => {
            if (innerFilter.apiaFilter.id === incomingFilter.id) {
              if (
                ['date', 'D'].includes(innerFilter.apiaFilter.type as string)
              ) {
                returnFilter = {
                  ...innerFilter,
                  apiaFilter: {
                    ...innerFilter.apiaFilter,
                    currentValue: incomingFilter.currentValue,
                    filterToValue: incomingFilter.filterToValue,
                    deleteFiltersTimestamp:
                      incomingFilter.deleteFiltersTimestamp,
                    changeFiltersTimestamp:
                      incomingFilter.changeFiltersTimestamp,
                    errorFrom:
                      !!incomingFilter.currentValue &&
                      innerFilter.apiaFilter.errorFrom === 'Filtro requerido'
                        ? undefined
                        : innerFilter.apiaFilter.errorFrom,
                    errorTo:
                      !!incomingFilter.filterToValue &&
                      innerFilter.apiaFilter.errorTo === 'Filtro requerido'
                        ? undefined
                        : innerFilter.apiaFilter.errorTo,
                    error:
                      !!incomingFilter.filterToValue &&
                      !!incomingFilter.currentValue &&
                      innerFilter.apiaFilter.error === 'Filtro requerido'
                        ? undefined
                        : innerFilter.apiaFilter.error,
                    savedValue: incomingFilter.savedValue,
                  },
                };
              } else {
                returnFilter = {
                  ...innerFilter,
                  apiaFilter: {
                    ...innerFilter.apiaFilter,
                    currentValue: incomingFilter.currentValue,
                    deleteFiltersTimestamp:
                      incomingFilter.deleteFiltersTimestamp,
                    changeFiltersTimestamp:
                      incomingFilter.changeFiltersTimestamp,
                    error:
                      !!incomingFilter.currentValue &&
                      innerFilter.apiaFilter.error === 'Filtro requerido'
                        ? undefined
                        : innerFilter.apiaFilter.error,
                    savedValue: incomingFilter.savedValue,
                  },
                };
              }
            }
          });
          return returnFilter;
        }),
        areAllFiltersApplied: false,
      }),
    );
    const changingFilters: TApiaFinderFilter[] = [];
    state.filters?.forEach((innerFilter) => {
      filters.forEach((incomingFilter) => {
        if (innerFilter.apiaFilter.id === incomingFilter.id) {
          changingFilters.push(innerFilter);
        }
      });
    });
    const hasDetectOnChange = filters.some(
      (innerFilter) => innerFilter.detectOnChange || innerFilter.detectOnChange,
    );
    if (hasDetectOnChange || forceSearch) {
      await queriesQueue.runAction(queueKey, async () => {
        await store.dispatch(
          search({
            fieldId,
            query,
            changingFilters,
            forceSearch,
            avoidDetectOnChangeAndSearch: avoidEventDetectOnChange,
            forceRefreshFromSavedFilters,
            queueKey: 'fromUpdateFilters',
          }),
        );
      }, [queueKey, 'fromUpdateFilters', 'fromSearchfromUpdateFilters']);
    }
    return null;
  },
);

export default updateFilter;
